import {entitiesService} from 'api/services/entities';
import cn from 'classnames';
import {AccessDenied} from 'components/AccessDenied/AccessDenied';
import {SearchResultsTable} from 'components/SearchResultsTable/SearchResultsTable';
import {useApi} from 'hooks/useApi';
import {useSubscriber} from 'hooks/useSubscriber';
import {useEffect, useMemo, useState} from 'react';
import {useNavigate} from 'react-router';

import homePageStyles from '../../HomePage.module.css';

export const RecentlyViewed = (props) => {
  const {onClickCell, broadcaster, visible} = props;
  const favorite = useApi({
    service: entitiesService.favorite,
    immediate: false
  });
  const unfavorite = useApi({
    service: entitiesService.unfavorite,
    immediate: false
  });
  const navigate = useNavigate();
  const subscriber = useSubscriber(broadcaster, 'recently-view');
  const recentlyViewed = useApi({service: entitiesService.recentlyViewed});
  const [pagination, setPagination] = useState({
    page: 0,
    count: 0,
    pageSize: 10
  });

  useEffect(() => {
    if (!recentlyViewed.loading) {
      setPagination((prev) => ({
        ...prev,
        count: recentlyViewed?.data?.length || 0
      }));
    }
  }, [recentlyViewed.loading]);

  useEffect(() => {
    if (!subscriber) {
      return;
    }
    return subscriber.on('data', (data) => {
      if (data.type === 'isFavorite') {
        recentlyViewed.execute();
      }
    });
  }, [subscriber]);

  const onUpdateFavorite = async (is_favorite, triton_id) => {
    const payload = {triton_id};
    const result = is_favorite ? await favorite.execute(payload) : await unfavorite.execute(payload);
    if (result instanceof Error) {
      return;
    }

    if (broadcaster) {
      broadcaster.sendData({
        type: 'isFavorite',
        isFavorite: is_favorite,
        tritonId: triton_id
      });
    }
  };

  const onPage = (page) => {
    setPagination({...pagination, page});
  };

  const onPageSize = (pageSize) => {
    setPagination({...pagination, pageSize});
  };

  const viewNetworksHandleClick = (tritonId) => {
    navigate(`/networks?triton_id=${tritonId}`);
  };

  const rows = useMemo(() => {
    if (!recentlyViewed?.data) {
      return [];
    }
    return recentlyViewed.data.map(({entity, is_favorite}) => ({
      ...entity,
      is_favorite
    }));
  }, [recentlyViewed.data, pagination]);

  return (
    <div className={cn(homePageStyles.resultsContainer, !visible && homePageStyles.hiddenTableStyles)}>
      {recentlyViewed.status === 403 && (
        <AccessDenied
          className={homePageStyles.accessDenied}
          absolute={true}
          title="You do not have permission to use the Recently Viewed table."
        />
      )}
      <SearchResultsTable
        rows={rows}
        loading={recentlyViewed.loading}
        onClickCell={onClickCell}
        viewNetworksHandleClick={viewNetworksHandleClick}
        onFavorite={onUpdateFavorite}
        pagination={pagination}
        onPage={onPage}
        onPageSize={onPageSize}
        dataGridProps={{
          paginationMode: 'client',
          sortingMode: 'client'
        }}
      />
    </div>
  );
};
